

import {
    StyleSheet, View, Text
} from "react-native";

import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';

import { ReactComponent as CloseImg } from '../../../img/ico-prefix-close.svg';
import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as SearchNoResultImg } from "../../../img/ico-search-no-result.svg";

import { ReactComponent as MoveImg } from "../../../img/ico-prefix-move.svg";
import { ReactComponent as SnapshotImg } from "../../../img/ico-prefix-snapshot.svg";
import { ReactComponent as SnapshotActiveImg } from "../../../img/ico-prefix-snapshot-white.svg";
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir-blue.svg';
import { ReactComponent as RedirActiveImg } from '../../../img/ico-prefix-redir-white.svg';
import { CustomImgBtn } from "../../base/CustomImgBtn";
import { VolumeData } from "./VolumeData";




interface VolumeDetailProps extends ContentContainerProps {
    updateVolumeFunction: Function;
    uploadVmImageFunction: Function;
    addSnapshotFunction: Function;
    updateSnapshotFunction: Function;
    deleteSnapshotFunction: Function;
    refreshYn: boolean;
    detailData: VolumeData | null;
}



export default function VolumeDetail(props:VolumeDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("VOLUME_MGMT_TITLE")} subtitle={t("VM_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData?.update_ts ? parseLocaleDatetime(props.detailData?.update_ts) : "-"}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData?.create_ts ? parseLocaleDatetime(props.detailData?.create_ts) : "-"}
                        </Text>
                    </View>
                </View>

                <View>
                    <View style={{...style.boxContainer, height: 530}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                            <Text style={style.boxContentTitleName}>
                                {props.detailData?.volume_name ? props.detailData?.volume_name : '-'}
                            </Text>
                            <div style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer", minWidth: 100}}
                                onClick={() => {
                                    props.updateVolumeFunction();
                                }}>
                                <TableEditImg/>
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("INFO_EDIT_TEXT")}
                                </Text>
                            </div>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30, height: 54}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.detailData?.volume_description ? props.detailData?.volume_description : '-'}
                            </Text>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("VOLUME_STATUS_TEXT")}
                            </Text>
                                {
                                    props.detailData?.volume_status_code === "AVB" ?
                                    <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#3a8344", overflow: "hidden"}}>
                                        <ActiveImg/>{t("AVAIL_TEXT")}
                                    </div>
                                    : props.detailData?.volume_status_code === "INUSE"?
                                    <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#8c8c8c", overflow: "hidden"}}>
                                        <IdleImg/>{t("INUSE_TEXT")}
                                    </div>
                                    :
                                    <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#e86045", overflow: "hidden"}}>
                                        <ErrorImg/>{t("UNAVAIL_TEXT")}
                                    </div>
                                }
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("BOOT_AVAILABLE_CHECK_TEXT")}
                            </Text>

                                {
                                    props.detailData?.boot_yn === true ?
                                    <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#0853fb", overflow: "hidden"}}>
                                        {t("BOOT_AVAILABLE_TEXT")}
                                    </div>
                                    :
                                    <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#0853fb", overflow: "hidden"}}>
                                        {t("BOOT_NOT_AVAILABLE_TEXT")}
                                    </div>

                                }
                        </View>

                        <View style={style.boxContentDivLine}></View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("AZ_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData?.availability_zone_id ? props.detailData?.availability_zone_id : '-'}
                                    </Text>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("VM_BASE_IMAGE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText}}>
                                        {props.detailData?.base_vm_image_name ? props.detailData?.base_vm_image_name : '-'}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("PROJECT_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color: "#0853fb"}}>
                                        {props.detailData?.project?.project_name ? props.detailData?.project?.project_name : '-'}
                                    </Text>
                                </View>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("VM_VOLUME_SIZE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color: "#3a8344"}}>
                                        {props.detailData?.volume_size_gb ? props.detailData?.volume_size_gb : 0}
                                    </Text>
                                    <Text style={style.resourceSubText}>GB</Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", height: 80, alignItems: "center", justifyContent: "center"}}>
                            <View>
                                <CustomImgBtn
                                    size={{width: 136, height: 36}}
                                    text={t("SNAPSHOT_VOLUME_CREATE_TEXT")}
                                    img={{
                                        active: <SnapshotActiveImg/>,
                                        inactive: <SnapshotImg/>,
                                    }}
                                    onPress={() => {props.addSnapshotFunction();}}
                                />
                            </View>
                            <View style={{marginLeft: 20}}>
                                <CustomImgBtn
                                    size={{width: 156, height: 36}}
                                    text={t("VM_IMAGE_SEND_TEXT")}
                                    img={{
                                        active: <RedirActiveImg/>,
                                        inactive: <RedirImg/>,
                                    }}
                                    onPress={() => {props.uploadVmImageFunction();}}
                                />
                            </View>
                        </View>
                    </View>

                    <View style={{...style.boxContainer, minHeight: 250}}>
                        <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                            <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("IN_USE_CONNECTION")}
                            </Text>
                            <Text style={{...style.boxContentTitleDescription}}>
                                {t("MESSAGE_VOLUME_IN_USE_CONNECTION_TITLE_DESCRIPTION_MESSAGE")}
                            </Text>
                        </View>
                        {
                            props.detailData?.mapping_device_name && props.detailData?.vm?.vm_id ?
                            <View key={props.detailData?.vm?.vm_id} style={{flexDirection: "row", alignItems: "center"}}>
                                <View style={{...style.innerItemContainer, flexDirection: "column", alignItems: "flex-start"}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                            {t("VM_INFO_TEXT")}
                                        </Text>
                                        <View style={style.innerDataContainer}>
                                            <Text style={style.innerDataGreenText}>
                                                {props.detailData?.vm?.vm_name}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 5}}>
                                        <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                            {t("CONNECTION_DEVICE_TEXT")}
                                        </Text>
                                        <View style={style.innerDataContainer}>
                                            {
                                            props.detailData?.mapping_device_name ?
                                            <Text style={style.innerDataBlueText}>
                                                { props.detailData?.mapping_device_name }
                                            </Text>
                                            :
                                            <Text style={style.innerDataGrayText}>
                                                { t("MESSAGE_NOT_PRINT_DEVICE_MESSAGE")}
                                            </Text>
                                            }
                                        </View>
                                    </View>
                                </View>
                            </View>
                            :
                            <View key={props.detailData?.vm?.vm_id} style={{flexDirection: "row", alignItems: "center"}}>
                                <View style={{...style.innerItemContainer, flexDirection: "column", alignItems: "flex-start"}}>
                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                        <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                            {t("VM_INFO_TEXT")}
                                        </Text>
                                        <View style={style.innerDataContainer}>
                                            <Text style={style.innerDataGrayText}>
                                                {t("MESSAGE_NOT_CONNECTION_VN_MESSAGE")}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={{flexDirection: "row", alignItems: "center", marginTop: 5}}>
                                        <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                            {t("CONNECTION_DEVICE_TEXT")}
                                        </Text>
                                        <View style={style.innerDataContainer}>
                                            {
                                            props.detailData?.mapping_device_name ?
                                            <Text style={style.innerDataBlueText}>
                                                { props.detailData?.mapping_device_name }
                                            </Text>
                                            :
                                            <Text style={style.innerDataGrayText}>
                                                { t("MESSAGE_NOT_CONNECTION_DEVICE_MESSAGE")}
                                            </Text>
                                            }
                                        </View>
                                    </View>
                                </View>
                            </View>
                        }
                    </View>

                    <View style={{...style.boxContainer, minHeight: 250}}>
                        <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                            <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("SNAPSHOT_VOLUME_TEXT")}
                            </Text>
                            <Text style={{...style.boxContentTitleDescription}}>
                                {t("MESSAGE_VOLUME_SNAPSHOT_TITLE_DESCRIPTION_MESSAGE")}
                            </Text>
                            <div
                                style={{
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    width: 70, height: 24,
                                    marginLeft: "auto",
                                    borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                    backgroundColor: "#fff",
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: "#333",
                                    cursor: "pointer",
                                }}
                                onClick={() => {props.addSnapshotFunction()}}
                            >
                                {t("CREATE_TEXT")}
                                <MoveImg style={{marginLeft: 3}}/>
                            </div>
                        </View>
                        {
                            props.detailData?.volume_snapshots && props.detailData.volume_snapshots.length > 0 ? props.detailData.volume_snapshots.map((v) => {
                            return (
                                <View key={v.volume_snapshot_id} style={{flexDirection: "row", alignItems: "center"}}>
                                    <View style={{...style.innerItemContainer, alignItems: "flex-start", minHeight: 50}}>
                                        <View>
                                            <Text style={{...style.innerItemName, width: 330, overflow:"hidden"}} numberOfLines={1}>
                                                {
                                                    v.volume_snapshot_name
                                                }
                                            </Text>
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center"}}>
                                            <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                                    {t("VOLUME_SNAPSHOT_STATUS_TEXT")}
                                            </Text>
                                            {
                                                v.volume_snapshot_status_code === "AVB" ?
                                                <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#3a8344", overflow: "hidden"}}>
                                                    <ActiveImg /> {t("AVAIL_TEXT")}
                                                </div>
                                                : v.volume_snapshot_status_code === "CRT"?
                                                <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#8c8c8c", overflow: "hidden"}}>
                                                    <IdleImg />{t("CREATING_TEXT")}
                                                </div>
                                                :
                                                <div style={{display: "flex", alignItems: "center", fontFamily: FONT.REGULAR, fontSize: 12, color: "#e86045", overflow: "hidden"}}>
                                                    <ErrorImg/>{t("UNAVAIL_TEXT")}
                                                </div>
                                            }
                                        </View>
                                        <View style={{flexDirection: "row", alignItems: "center", marginLeft: 30, marginTop: 2}}>
                                            <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                                                <Text style={style.dateTitle}>
                                                    {t("CREATE_DATE_TEXT")}
                                                </Text>
                                                <Text style={style.dateData}>
                                                    {v.create_ts ? parseLocaleDatetime(v.create_ts) : "-"}
                                                </Text>
                                            </View>
                                        </View>
                                        <div
                                            style={{
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                width: 65, height: 24,
                                                marginLeft: "auto",
                                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                backgroundColor: "#fff",
                                                fontFamily: FONT.REGULAR,
                                                fontSize: 12,
                                                color: "#333",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {props.updateSnapshotFunction(v)}}
                                        >
                                            {t("UPDATE_TEXT")}
                                            <MoveImg style={{marginLeft: 3}}/>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                width: 65, height: 24,
                                                marginLeft: 10,
                                                borderRadius: 2, borderStyle: "solid", borderWidth: 1, borderColor: "#d4d0db",
                                                backgroundColor: "#fff",
                                                fontFamily: FONT.REGULAR,
                                                fontSize: 12,
                                                color: "#333",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {props.deleteSnapshotFunction(v)}}
                                        >
                                            {t("DELETE_TEXT")}
                                            <CloseImg style={{marginLeft: 3}}/>
                                        </div>
                                    </View>
                                </View>
                                )
                            })
                            :
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <View key={99} style={{...style.innerItemContainer, justifyContent:"center"}}>
                                    <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                    <Text style={style.innerItemEmtpyText}>
                                        {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                    </Text>
                                </View>
                            </View>
                        }
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitleName: {
        fontFamily: FONT.BOLD,
        fontSize: 20,
        color: "#494a4d"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentTitleDescription: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentDivLine: {
        height: 1,
        border: "solid 0.5px #eee", marginBottom: 30
    },
    innerItemEmtpyText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#4d5367"
    },
    innerItemEmptyImg: {
        width: 50,
        height: 50,
        marginRight: 30,
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 32,
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 120,
        marginRight: 45,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        width: 50,
        fontFamily: FONT.BOLD,
        textAlign: "right",
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        width: 40,
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    innerItemContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        marginBottom: 30, marginTop: 10, minHeight: 80,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 0.8,
        borderColor: "#d2d5d9",
        paddingLeft: 30,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
    },
    innerItemName: {
        marginLeft: 10,
        width: 130,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerDataContainer: {
        marginLeft: 30,
        flexDirection: "row",
        alignItems: "center",
        width: 400,
        height: 36,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        paddingLeft: 20
    },
    innerItemBlueText: {
        width: 120,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerItemText: {
        width: 80,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerColumnDivLine: {
        height: 18,
        borderColor: "#d2d5d9",
        borderStyle: "solid",
        borderWidth: 0.8
    },
    innerDataGreenText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#3a8344"
    },
    innerDataBlueText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#0853fb"
    },
    innerDataGrayText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
});